import axios from 'axios'
import { AppUrl } from '@/assets/js/variables'

const state = {
  // alerts: [],
  alerts: {
    multiple: {
      items: [],
      loading: false,
      noData: false
    },
    single: {
      items: [],
      loading: false,
      noData: false
    }
  },
  multiple: {
    sellers: [
      { id: '0', name: 'All' }
    ],
    brands: [
      { id: '0', name: 'All' }
    ],
    categories: [
      { id: '0', name: 'All' }
    ]
  },
  single: {
    sellers: [
      { id: '0', name: 'All' }
    ],
    brands: [],
    categories: [],
    products: [],
    skus: []
  }
}

const getters = {

}

const actions = {
  getAlerts ({ commit }, filter) {
    commit('SET_loading', true)
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getmyAlerts'
      })
        .then(response => {
          if (response.data.payload) {
            commit('SET_alerts', response.data.payload)
            commit('SET_loading', false)
          }
          resolve()
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  getMultipleAlerts ({ commit }, filter) {
    commit('SET_multipleLoading', true)
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getmyAlerts'
      })
        .then(response => {
          if (response.data.payload.multipleAlerts.length) {
            commit('SET_multipleAlerts', response.data.payload.multipleAlerts)
            commit('SET_multipleNoData', false)
            commit('SET_multipleLoading', false)
          } else {
            commit('SET_multipleLoading', false)
            commit('SET_multipleNoData', true)
          }
          resolve()
        })
        .catch(error => {
          commit('SET_multipleLoading', false)
          commit('SET_multipleNoData', true)
          console.log(error)
        })
    })
  },
  getSingleAlerts ({ commit }, filter) {
    commit('SET_singleLoading', true)
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getmyAlerts'
      })
        .then(response => {
          if (response.data.payload.singleAlerts.length) {
            commit('SET_singleAlerts', response.data.payload.singleAlerts)
            commit('SET_singleNoData', false)
            commit('SET_singleLoading', false)
          } else {
            commit('SET_singleLoading', false)
            commit('SET_singleNoData', true)
          }
          resolve()
        })
        .catch(error => {
          commit('SET_singleLoading', false)
          commit('SET_singleNoData', true)
          console.log(error)
        })
    })
  },
  deleteAlerts ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'deleteAlert',
        payload: {
          alertIds: filter.alertId
        }
      })
        .then(response => {
          if (response.data.payload) {
            resolve()
          }
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  getMultipleAlertSeller ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getSeller',
        payload: {
          seller_name: filter.sellerName,
          brand_id: filter.brandId,
          category_id: filter.categoryId,
          product_id: filter.productId,
          sku: '',
          page_id: 'alerts'
        }
      })
        .then(response => {
          if (response.data.payload) {
            commit('SET_multipleSellers', response.data.payload.seller)
          }
          resolve()
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  getMultipleAlertBrand ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getBrand',
        payload: {
          brand_name: filter.brandName,
          seller_id: filter.sellerId,
          category_id: filter.categoryId,
          product_id: filter.productId,
          sku: '',
          page_id: 'alerts'
        }
      })
        .then(response => {
          if (response.data.payload) {
            commit('SET_multipleBrands', response.data.payload.brand)
          }
          resolve()
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  getMultipleAlertCategory ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getCategory',
        payload: {
          category_name: filter.categoryName,
          seller_id: filter.sellerId,
          brand_id: filter.brandId,
          product_id: filter.productId,
          sku: '',
          page_id: 'alerts'
        }
      })
        .then(response => {
          if (response.data.payload) {
            commit('SET_multipleCategories', response.data.payload.category)
          }
          resolve()
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  saveMultipleAlert ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'saveAlert',
        payload: {
          alert_name: filter.alertName,
          seller_id: filter.sellerId,
          brand_id: filter.brandId,
          category_id: filter.categoryId,
          receiving_time_1: filter.receive1,
          receiving_time_2: filter.receive2,
          product_id: 0,
          sku: '',
          alertType: 2
        }
      })
        .then(response => {
          console.log(filter)
          if (response.data.payload) {
            resolve()
          }
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  getSingleAlertSeller ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getSeller',
        payload: {
          seller_name: filter.sellerName,
          brand_id: filter.brandId,
          category_id: filter.categoryId,
          product_id: filter.productId,
          sku: filter.sku === 0 ? '' : filter.sku,
          page_id: 'alerts'
        }
      })
        .then(response => {
          if (response.data.payload) {
            commit('SET_singleSellers', response.data.payload.seller)
          }
          resolve()
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  getSingleAlertBrand ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getBrand',
        payload: {
          brand_name: filter.brandName,
          seller_id: filter.sellerId,
          category_id: filter.categoryId,
          product_id: filter.productId,
          sku: filter.sku === 0 ? '' : filter.sku,
          page_id: 'alerts'
        }
      })
        .then(response => {
          if (response.data.payload) {
            commit('SET_singleBrands', response.data.payload.brand)
          }
          resolve()
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  getSingleAlertProduct ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getProduct',
        payload: {
          product_name: filter.productName,
          seller_id: filter.sellerId,
          category_id: filter.categoryId,
          brand_id: filter.brandId,
          sku: filter.sku === 0 ? '' : filter.sku,
          page_id: 'alerts'
        }
      })
        .then(response => {
          if (response.data.payload) {
            commit('SET_singleProducts', response.data.payload.product)
          }
          resolve(response)
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  getSingleAlertSku ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getSku',
        payload: {
          sku: filter.sku,
          seller_id: filter.sellerId,
          category_id: filter.categoryId,
          brand_id: filter.brandId,
          product_id: filter.productId,
          page_id: 'alerts'
        }
      })
        .then(response => {
          if (response.data.payload) {
            commit('SET_singleSkus', response.data.payload.sku_result)
          }
          resolve()
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  saveSingleAlert ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'saveAlert',
        payload: {
          alert_name: filter.alertName,
          seller_id: filter.sellerId,
          brand_id: filter.brandId,
          product_id: filter.productId,
          receiving_time_1: filter.receive1,
          receiving_time_2: filter.receive2,
          sku: filter.sku,
          alertType: 1
        }
      })
        .then(response => {
          console.log(filter)
          if (response.data.payload) {
            resolve()
          }
        })
        .catch(error => {
          console.log(error)
        })
    })
  }
}

const mutations = {
  SET_alerts (state, data) {
    state.alerts = data
  },
  SET_multipleAlerts (state, data) {
    state.alerts.multiple.items = data
  },
  SET_multipleLoading (state, bool) {
    state.alerts.multiple.loading = bool
  },
  SET_multipleNoData (state, bool) {
    state.alerts.multiple.noData = bool
    if (bool) {
      state.alerts.multiple.items = []
    }
  },
  SET_singleAlerts (state, data) {
    state.alerts.single.items = data
  },
  SET_singleLoading (state, bool) {
    state.alerts.single.loading = bool
  },
  SET_singleNoData (state, bool) {
    state.alerts.single.noData = bool
    if (bool) {
      state.alerts.single.items = []
    }
  },
  SET_multipleSellers (state, data) {
    data.unshift({id: '0', name: 'All'})
    state.multiple.sellers = data
  },
  SET_multipleBrands (state, data) {
    data.unshift({id: '0', name: 'All'})
    state.multiple.brands = data
  },
  SET_multipleCategories (state, data) {
    data.unshift({id: '0', name: 'All'})
    state.multiple.categories = data
  },
  SET_singleSellers (state, data) {
    data.unshift({id: '0', name: 'All'})
    state.single.sellers = data
  },
  SET_singleBrands (state, data) {
    state.single.brands = data
  },
  SET_singleProducts (state, data) {
    state.single.products = data
  },
  SET_singleSkus (state, data) {
    state.single.skus = data
  },
  RESET_singleSkus (state, data) {
    state.single.skus = []
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/alerts.js